export enum BidResponseDocumentType {
  TECHNICAL_MEMO = 'TECHNICAL_MEMO',
  RESPONSE_FRAMEWORK = 'RESPONSE_FRAMEWORK',
  CLIENT_REFERENCES = 'CLIENT_REFERENCES',
  CV = 'CV',
  DATA_POLICY = 'DATA_POLICY',
  CSR_POLICY = 'CSR_POLICY',
  CERTIFICATION = 'CERTIFICATION',
  PRODUCT_SHEET = 'PRODUCT_SHEET',
  OTHER = 'OTHER',
  UNKNOWN = 'UNKNOWN',
}

export type BidResponseDocument = {
  id: number;
  originalName: string;
  prettyName: string;
  S3FileURL: string;
  S3PreviewFileURL: string;
  type: BidResponseDocumentType;
  originalFilePath: string;
  bidResponseId: number;
};
